import React, { Component } from "react";
import { Box, Typography } from "@mui/material";
import HelpHint from "./helpHint";

class GettingStarted extends Component {
  render() {
    return (
      <>
        <Box
          sx={{
            textAlign: "left",
            mt: 4,
            pb: 2,
            display: { xs: "none", lg: "block" },
          }}
        >
          <Typography variant="h4" sx={{ my: 5 }}>
            Welcome to ShieldShot!
            <HelpHint
              title="Getting started"
              hints={[
                "Use the navigation on the left to explore ShieldShot features.",
                "Create collections of email addresses to receive your distributions.",
                "Set up tiers to organize subscribers by reward level.",
              ]}
            />
          </Typography>
          <p>
            Let's get started. See the video tutorials below to learn how to use
            ShieldShot. Since we're still in beta, please expect some bugs here
            and there — we're fixing and adding features as we go.
          </p>
          <p className="mt-5">
            Or if you prefer to watch video tutorials instead, see the videos
            below to get you started.
          </p>
        </Box>
        <Box sx={{ textAlign: "left" }}>
          <iframe
            width="560"
            height="315"
            title="ShieldShot Tutorial"
            src="https://www.youtube.com/embed/FA4N-2TSZ6U"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </Box>
      </>
    );
  }
}

export default GettingStarted;
